import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { toastError } from '@components/Toast';

import Chip from '@features/filter/Chip';
import Search from '@features/filter/Common/Search';
import Sort from '@features/filter/Common/Sort';
import QuickFilterSupplier from '@features/filter/v2/QuickFilterSupplier';
import InviteTeamMember from '@features/supplier/component/InviteTeamMember';

import ApiClient from '@lib/apiClient';

import { checkAnyUserType } from '@utils/Util';

const FilterTopHeaderOfSupplier = ({
	toggleFilter,
	searchBoxPlaceHolder,
	addNewTitle,
	totalElements,
	selectedViewType,
	onSetViewSetting
}) => {
	const [isShowQuickFilter, setIsShowQuickFilter] = useState(false);
	const filterFields = useSelector((store) => store.filterFieldStore);
	const [, setSelectedTab] = useState('');
	const [isShowInvite, setIsShowInvite] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		let activeTab = filterFields?.status || [];
		let currentTabOfGlobal = activeTab.find((item) => item.type === 'SELECT');
		setSelectedTab(currentTabOfGlobal?.key);
	}, [filterFields]);

	return (
		<>
			<div className="filter-container-top">
				<div className="filters">
					<div className="filter-toggle" onClick={() => toggleFilter()}>
						<img src={process.env.PUBLIC_URL + '/icons/filter24.svg'} alt="filter" />
						<span>Filter</span>
					</div>
					<span className="items-count semibold-14 gray_dark_02 mr-2">
						{totalElements > 0 ? totalElements : 0} Supplier
					</span>
					<Chip />
				</div>
				<div className={`filter-actions collections-filter-actions ${addNewTitle}`}>
					<Search placeholder={searchBoxPlaceHolder} identifier="search" />
					<div className="quick-btn mr-3 ml-3">
						<button className="button size32" onClick={() => setIsShowQuickFilter(true)}>
							Quick Search
						</button>
					</div>
					<div>
						<div className="sort-button design-view-sort">
							<div className="dropdown show">
								<button
									className="btn btn-default dropdown-toggle gray_dark_02 regular-14 p-0 pr-2"
									type="button"
									data-toggle="dropdown"
									aria-expanded="true"
								>
									{selectedViewType === 'IMAGE_VIEW' ? (
										<img src={`${process.env.PUBLIC_URL}/icons/grid.svg`} alt="add" />
									) : (
										<img src={`${process.env.PUBLIC_URL}/icons/list.svg`} alt="add" />
									)}
								</button>
								<ul
									className="dropdown-menu dropdown-menu-right shadow-4dp"
									x-placement="bottom-end"
								>
									<li
										className={`cursor-pointer`}
										onClick={() => {
											if (selectedViewType !== 'IMAGE_VIEW') {
												onSetViewSetting('IMAGE_VIEW');
											}
										}}
									>
										<img src={`${process.env.PUBLIC_URL}/icons/grid.svg`} alt="add" />
										Grid
									</li>
									<li
										onClick={() => {
											if (selectedViewType !== 'LIST_VIEW') {
												onSetViewSetting('LIST_VIEW');
											}
										}}
										className={`cursor-pointer`}
									>
										<img src={`${process.env.PUBLIC_URL}/icons/list.svg`} alt="add" />
										List
									</li>
								</ul>
							</div>
						</div>
					</div>
					<Sort title={'SUPPLIER_LIST'} removedLastModified={true} />

					{addNewTitle === 'Supplier' &&
						checkAnyUserType([
							'ADMIN',
							'SUPPLY_CHAIN',
							'MATERIAL_MANAGEMENT',
							'INVENTORY_MANAGEMENT'
						]) && (
							<div className="add-new-design d-flex">
								<button
									className="button text size32 px-0"
									onClick={() => {
										ApiClient.POST('supplierAddFromListEvent', {})
											.then(() => {
												navigate('/suppliers/add');
											})
											.catch(() => {
												toastError('Event was unsuccessful!');
											});
									}}
								>
									<img src={process.env.PUBLIC_URL + '/icons/add-round.svg'} alt="add" />
									<span className="ml-1">{addNewTitle}</span>
								</button>
								<button
									className="button text size32 px-0 ml-2"
									onClick={() => setIsShowInvite(true)}
								>
									<img src={process.env.PUBLIC_URL + '/icons/add-round.svg'} alt="add" />
									<span className="ml-1">Invite</span>
								</button>
							</div>
						)}
				</div>
			</div>
			{isShowQuickFilter && <QuickFilterSupplier onClose={() => setIsShowQuickFilter(false)} />}
			{isShowInvite && <InviteTeamMember onClose={() => setIsShowInvite(false)} />}
		</>
	);
};

export default FilterTopHeaderOfSupplier;
